<template>
  <div class="container-fluid bg-white">
    <div class="row" v-if="mix">
      <div class="col-12 col-lg-6 px-4">
        <MixEditForm
          :mix="mix"
          :artists="artists"
          :songs="songs"
          :needs-merge-confirm="false"
          :other-mixes="otherMixes"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MixEditForm from '../mix_edit_form.vue'
import { mixesStore } from '../path_store'
import sidebarStore from '../sidebar_store'

export default {
  components: { MixEditForm },
  data() {
    return {
      fetchedMix: null,
      otherMixes: [],
    }
  },
  watch: {
    "$route": {
      handler() {
        this.fetchData()
      },
      immediate: true
    }
  },
  methods: {
    async fetchData() {
      const id = this.mixId
      if (!this.mix) {
        const r = await fetch(`/mixes/${id}.json?view=vue`)
        if (r.ok) this.fetchedMix = await r.json()
      }
      const songId = this.mix?.song_id
      if (!songId) {
        return
      }

      const r = await fetch(`/songs/${songId}.json?view=vue&include_markers=true`)
      if (r.ok) {
        const { mixes } = await r.json()
        this.otherMixes = (mixes || [])
          .filter(m => m.id !== id && m.marker_count > 0)
      }
    },
  },
  computed: {
    mixId() {
      return parseInt(this.$route.params.mixID)
    },
    mix() {
      return mixesStore.items.find(m => m.id === this.mixId) || this.fetchedMix
    },
    artists() {
      return sidebarStore.artists.map(a => a.name)
    },
    songs() {
      return sidebarStore.artists.flatMap(artist =>
        sidebarStore.songs
          .filter(s => s.artist_id === artist.id)
          .map(s => ({ name: s.name, artist_name: artist.name }))
      )
    },
  },
}
</script>
